(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-header"] && !Shopify.designMode) return;
  try {
    
function stormberryMenu(root) {
  const button = root.querySelector('.menu-toggle');
  const menu = root.querySelector('.mobile-nav');
  if (!button || !menu || button.dataset.ready) return;
  button.dataset.ready = 'true';
  const setMenu = (open) => {
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? button.dataset.closeLabel : button.dataset.openLabel);
    menu.dataset.open = String(open);
  };
  button.addEventListener('click', () => setMenu(button.getAttribute('aria-expanded') !== 'true'));
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
      setMenu(false);
      button.focus();
    }
  });
}
document.querySelectorAll('.sb-home').forEach(stormberryMenu);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sb-home').forEach(stormberryMenu));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-trading-guide"] && !Shopify.designMode) return;
  try {
    
function setupStormberryTradeDemo(root) {
  root.querySelectorAll('.sb-trade-demo').forEach(demo => {
    if (demo.dataset.ready) return;
    const buttons = [...demo.querySelectorAll('.sb-demo-button')];
    const response = demo.querySelector('.sb-demo-response');
    const title = demo.querySelector('.sb-demo-title');
    const message = demo.querySelector('.sb-demo-message');
    const guide = demo.closest('.trade-guide');
    const photos = [...guide.querySelectorAll('[data-trade-photo]')];
    if (!response || !title || !message || !buttons.length) return;
    let request = 0;
    const warmPhotos = () => photos.forEach(photo => { photo.querySelector('img').loading = 'eager'; });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          warmPhotos();
          observer.disconnect();
        }
      }, { rootMargin: '300px' });
      observer.observe(guide);
    }
    demo.dataset.ready = 'true';
    buttons.forEach(button => button.addEventListener('click', async () => {
      const current = ++request;
      const symbol = button.dataset.symbol;
      const photo = photos.find(item => item.dataset.tradePhoto === symbol);
      const img = photo?.querySelector('img');
      if (img) {
        img.loading = 'eager';
        if (!img.complete) {
          demo.setAttribute('aria-busy', 'true');
          try { await img.decode(); } catch {}
        }
      }
      if (current !== request) return;
      demo.removeAttribute('aria-busy');
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      demo.dataset.selected = symbol;
      title.textContent = button.querySelector('span').textContent;
      message.textContent = button.dataset.response;
      if (photo) photos.forEach(item => { item.hidden = item !== photo; });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        response.animate([{ opacity: .45, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
      }
    }));
  });
}
setupStormberryTradeDemo(document);
document.addEventListener('shopify:section:load', event => setupStormberryTradeDemo(event.target));

  } catch(e) { console.error(e); }
})();
})();
